import { render } from "./ApprovalModal.vue?vue&type=template&id=523613b1&scoped=true"
import script from "./ApprovalModal.vue?vue&type=script&lang=js"
export * from "./ApprovalModal.vue?vue&type=script&lang=js"

import "./ApprovalModal.vue?vue&type=style&index=0&id=523613b1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523613b1"]])

export default __exports__